import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock"
import GridContainer from "@/components/common/GridContainer"
import { getMapKey, groupArrayBySize } from "@/utils/utils"
import SingleTile from "@/components/TilesModule/variants/TilesLogo/SingleTile"
import { useIsDesktop } from "@/hooks/useDevice"

function getData(data) {
	return {
		tiles: data?.tiles || [],
		indent: data?.indent,
	}
}

export default function TilesLogo({ data, paddings, headerDescription }) {
	const isDesktop = useIsDesktop()
	const { tiles, indent } = getData(data)

	const groupSize = indent ? 3 : 4
	const groupedTiles = groupArrayBySize(tiles, isDesktop ? groupSize : tiles.length)
	const indentValue = indent ? 2 : 0

	return (
		<section className={paddings}>
			<HeaderDescriptionBlock headerDescription={headerDescription} />
			{groupedTiles.map((group, index) => {
				return (
					<GridContainer key={getMapKey(group, index)} className={`indent-desktop-${indentValue}`}>
						{group.map((tile, index) => (
							<SingleTile key={getMapKey(tile, index)} item={tile} />
						))}
					</GridContainer>
				)
			})}
		</section>
	)
}
